import logo2 from "assets/images/logo-2.svg";
import logoMain from "assets/images/logo-main.svg";
import logoTeamDark from "assets/images/logo-team-dark.svg";
import logoTeamLight from "assets/images/logo-team-light.svg";
import logoTextCol2 from "assets/images/logo-text-col-2.svg";
import logoTextCol from "assets/images/logo-text-col.svg";
import logoTextRowDark from "assets/images/logo-text-row-dark.png";
import logoTextRow from "assets/images/logo-text-row.svg";
import logo from "assets/images/logo.svg";
import { config } from "constant";
import { ComponentProps } from "react";
import Image from "./Image";

type Props = Omit<ComponentProps<typeof Image>, "src" | "alt"> & {
  variant?:
    | "DEFAULT"
    | "DEFAULT-2"
    | "logo-text-row"
    | "logo-text-row-dark"
    | "logo-text-col"
    | "logo-text-col-2"
    | "logo-team-light"
    | "logo-team-dark"
    | "logo-main";
};

export default function Logo({ variant = "DEFAULT", ...props }: Props) {
  const variants = {
    DEFAULT: logo,
    "DEFAULT-2": logo2,
    "logo-text-row": logoTextRow,
    "logo-text-row-dark": logoTextRowDark,
    "logo-text-col": logoTextCol,
    "logo-text-col-2": logoTextCol2,
    "logo-team-light": logoTeamLight,
    "logo-team-dark": logoTeamDark,
    "logo-main": logoMain,
  };
  return <Image src={variants[variant]} alt={config.title} {...props} />;
}
